import { create } from 'zustand'

interface WebSocketStore {
  isConnected: boolean
  isConnecting: boolean
  error: string | null
  connectionId: string | null

  socket: WebSocket | null
  reconnectTimeout: number | null

  // Actions
  setConnected: (isConnected: boolean) => void
  setConnecting: (isConnecting: boolean) => void
  setError: (error: string | null) => void
  setConnectionId: (connectionId: string | null) => void
  reset: () => void

  // Connection management
  connect: () => Promise<void>
  disconnect: () => Promise<void>

  // Internal state for WebSocket instance
  setSocket: (socket: WebSocket | null) => void
  setReconnectTimeout: (timeout: number | null) => void
}

export const useWebSocketStore = create<WebSocketStore>(set => ({
  // Initial state
  isConnected: false,
  isConnecting: false,
  error: null,
  connectionId: null,
  socket: null,
  reconnectTimeout: null,

  // State setters
  setConnected: (isConnected: boolean) => set({ isConnected }),
  setConnecting: (isConnecting: boolean) => set({ isConnecting }),
  setError: (error: string | null) => set({ error }),
  setConnectionId: (connectionId: string | null) => set({ connectionId }),
  setSocket: (socket: WebSocket | null) => set({ socket }),
  setReconnectTimeout: (reconnectTimeout: number | null) => set({ reconnectTimeout }),

  // Reset state
  reset: () =>
    set({
      isConnected: false,
      isConnecting: false,
      error: null,
      connectionId: null,
      socket: null,
      reconnectTimeout: null,
    }),

  // Connection management (these will be implemented in the hook)
  connect: async () => {
    // This will be implemented in the hook that uses this store
    console.log('Connect called from store')
  },

  disconnect: async () => {
    // This will be implemented in the hook that uses this store
    console.log('Disconnect called from store')
  },
}))
